import { inject, injectable } from 'inversify';
import Debug from 'debug';
import { CommandHandler, createCommand } from '@/app/tracking/api';
import { UpdateQuizSessionTrackingCommand, UpdateQuizSessionTrackingCommandPayload } from '../api'
import { QuizSessionSuspendDataStore } from '../common';

const debug = Debug('scorm2004-update-quiz-session-command-handler')

@injectable()
export class Scorm2004UpdateQuizSessionCommandHandler implements CommandHandler<UpdateQuizSessionTrackingCommand> {

  constructor (
    @inject(QuizSessionSuspendDataStore)
    private store: QuizSessionSuspendDataStore,
  ) {}
  
  public async execute(command: UpdateQuizSessionTrackingCommandPayload) {

    debug('execute', command)

    await this.store.execute(createCommand<UpdateQuizSessionTrackingCommand>('update-quiz-session', command))
  }
}
